<template>
  <div class="data-table">
    <slot name="table-pre-header" />
    <!-- blur left -->
    <div v-show="blurLeft" class="blur-effect left"></div>
    <div class="data-table__wrapper" @scroll="runBlurEffect">
      <table v-if="tableItems" class="data-table__table">
        <!-- TABLE HEADER -->
        <thead class="data-table__header">
          <tr class="data-table__row">
            <!-- headers -->
            <th
              v-for="header in headers"
              :key="header.text"
              class="data-table__row-heading"
              :class="[sortableClass(header), `data-table__row-heading--${header.value}`]"
              @click="header.sortable && sortByheader(header)"
            >
              <div class="data-table__row-heading-content">
                <span>{{ header.text }}</span>
                <AppIcon v-if="header.sortable" icon="fas fa-sort" />
              </div>
            </th>
          </tr>
        </thead>
        <!-- TABLE BODY -->
        <tbody class="data-table__body">
          <!-- item row  -->
          <tr v-for="row in tableItems" :key="row.id" class="data-table__body-row">
            <!-- item row cell  -->
            <td
              v-for="(option, idx) in headers"
              :key="`option-${idx}`"
              class="data-table__body-col"
              :class="`data-table__body-col--${option.value}`"
            >
              <slot name="table-item" :current-row="row" :current-option="option" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- blur right -->
    <div v-show="blurRight" class="blur-effect right"></div>
    <!-- TABLE FOOTER -->
    <div class="data-table__footer">
      <slot name="table-add-ons" />
    </div>
  </div>
</template>

<script>
// Utilities
import { sortArrayByObjectKey } from 'Utils'
//Components
import AppIcon from 'Ui/AppIcon'

export default {
  name: 'DataTable',

  components: {
    AppIcon,
  },

  props: {
    headers: {
      type: Array,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      tableItems: this.items,
      orderInverted: false,
      blurLeft: false,
      blurRight: false,
    }
  },

  methods: {
    runBlurEffect() {
      const target = this.$el.querySelector('.data-table__wrapper')
      const scrollLeft = target.scrollLeft
      const scrollOffset = 0
      // acá esta el error de blur right ⤵
      const scrollRightEnd = target.scrollWidth - (target.offsetWidth - scrollOffset)
      if (scrollLeft === 0 && this.blurLeft) this.blurLeft = false
      if (scrollLeft > 0 && !this.blurLeft) this.blurLeft = true
      if (scrollLeft === scrollRightEnd && this.blurRight) this.blurRight = false
      if (scrollLeft !== scrollRightEnd && !this.blurRight) this.blurRight = true
      // console.log(scrollLeft, scrollRightEnd)
    },

    sortByheader(header) {
      const sortBy = header.sortablePath ? header.sortablePath : header.value

      // using unformated date keys
      if (header === 'modified_formated') header = 'modified'
      if (header === 'created_formated') header = 'created'

      sortArrayByObjectKey(this.tableItems, sortBy, this.orderInverted)
      this.orderInverted = !this.orderInverted
    },
  },

  computed: {
    sortableClass() {
      return (item) => {
        return item.sortable ? 'sortable' : ''
      }
    },
  },

  watch: {
    items(newValue) {
      if (newValue) this.tableItems = newValue
    },
  },

  mounted() {
    this.runBlurEffect()
    window.addEventListener('resize', this.runBlurEffect)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.runBlurEffect)
  },
}
</script>

<style scoped>
.data-table {
  display: -ms-inline-grid;
  display: inline-grid;
  position: relative;
  min-width: 100%;
  box-shadow: 0 0 30px -5px var(--rgba-default);
  overflow: hidden;
  border-radius: 10px;
}

.data-table__wrapper {
  max-height: 700px;
  /* margin-right: -15px; */
  z-index: 0;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow: scroll;
}

.data-table__wrapper::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.data-table__table {
  font-size: 14px;
  width: 100%;
  color: var(--c-primary);
  border-right: 0;
  border-collapse: collapse;
  text-transform: capitalize;
}

.data-table__header {
  position: relative;
  z-index: 5;
}

.data-table__header .data-table__row {
  width: 100%;
}

.data-table__row-heading {
  position: sticky;
  top: 0;
  font-size: 17px;
  color: #fff;
  height: 44px;
  min-width: 80px;
  padding: 15px 24px;
  text-align: left;
  background-color: var(--c-primary);
  vertical-align: middle;
  user-select: none;
}

.data-table__row-heading-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.data-table__row-heading:first-of-type {
  min-width: 150px;
}

.data-table__body-row {
  border-bottom: 1px solid var(--c-secondary-400);
}

.data-table__body-row:hover {
  background-color: var(--c-secondary-300);
}

.data-table__body-col {
  text-align: left;
  hyphens: auto;
  height: 72px;
  overflow-wrap: break-word;
  padding: 16px 24px;
  vertical-align: middle;
  white-space: nowrap;
}

.data-table__body-col img {
  width: 35px;
  height: auto;
}

.data-table__body-col:first-of-type {
  font-weight: 600;
  text-transform: none;
}

.data-table__body-col .app-link {
  text-decoration: none;
}

.data-table__body-col .app-link:hover {
  text-decoration: underline;
}

.data-table__menu-trigger {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 20px;
}

.data-table__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid var(--c-secondary-400);
  border-top: 0;
  padding: 10px;
  background-color: var(--c-secondary-300);
}
/* effects */
.blur-effect {
  position: absolute;
  top: 0;
  height: 100%;
  width: 14px;
  z-index: -1;
}

.blur-effect.left {
  left: 0;
  background-image: linear-gradient(to left, rgba(234, 240, 246, 0), rgb(234, 240, 246));
}

.blur-effect.right {
  /* right: 15px; */
  right: 0;
  background-image: linear-gradient(to right, rgba(234, 240, 246, 0), rgb(234, 240, 246));
}

.sortable {
  cursor: pointer;
}

.sortable:hover {
  background-color: var(--c-secondary-700);
}

.sortable .app-icon {
  color: #fff;
}
</style>
